import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function HeroSection() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  function handleCategorySelect(url: string) {
    setIsOpen(false);
    window.open(url, '_blank', 'noopener,nofollow');
  }

  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20toned%20minimalist%20modern%20workspace%20scene%20with%20open%20laptop%20on%20clean%20light%20wooden%20desk%20showing%20colorful%20spreadsheet%20dashboard%20interface%2C%20ceramic%20coffee%20mug%2C%20natural%20linen%20notebook%2C%20small%20terracotta%20potted%20plant%2C%20soft%20diffused%20morning%20sunlight%20through%20sheer%20curtain%2C%20cream%20wall%20background%2C%20cozy%20productive%20atmosphere%2C%20editorial%20magazine%20quality%20lifestyle%20photography%2C%20earthy%20warm%20palette%20with%20sand%20beige%20and%20sage%20accents%2C%20no%20text%20no%20watermark&width=1600&height=900&seq=hero-gtbuy-v3&orientation=landscape"
        alt="GTBuy Spreadsheet workspace scene"
        title="GTBuy Spreadsheet - Best Spreadsheet System for Buying Agents & E-commerce Sellers"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full h-full flex flex-col justify-center px-4 md:px-10">
        <div className="max-w-2xl">
          <span className="inline-block px-3 py-1.5 border border-white/30 rounded-full text-white/90 text-xs font-medium mb-5 tracking-wide whitespace-nowrap">
            SPREADSHEET AUTOMATION SYSTEM
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-semibold text-white leading-tight mb-4">
            GTBuy Spreadsheet
          </h1>
          <p className="text-lg md:text-xl text-white/80 font-light mb-8 max-w-lg leading-relaxed">
            The complete spreadsheet system for buying agents, e-commerce sellers &amp; dropshippers. Track orders, automate workflows, and maximize profit.
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div ref={dropdownRef} className="relative w-full sm:w-72">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="w-full flex items-center justify-between px-5 py-3.5 bg-white/95 backdrop-blur-sm text-foreground-800 rounded-full text-sm font-medium cursor-pointer hover:bg-white transition-colors"
              >
                <span className="whitespace-nowrap">Browse Categories</span>
                <i className={`ri-arrow-down-s-line text-lg transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {isOpen && (
                <div className="absolute top-full mt-2 left-0 right-0 bg-background-50 rounded-lg py-2 max-h-72 overflow-y-auto shadow-lg border border-background-200/70 z-20">
                  {categories.map((cat) => (
                    <button
                      key={cat.seq}
                      onClick={() => handleCategorySelect(cat.url)}
                      className="w-full text-left px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-900 cursor-pointer transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>

          <div className="mt-10">
            <Link
              to="/article/shopping-guide-kaspreadsheet"
              className="inline-flex items-center gap-2 text-white/90 hover:text-white text-sm font-medium transition-colors cursor-pointer"
            >
              Read the Shopping Guide
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}